<div class="modal-content">

  <div class="popup-loader" *ngIf="isDropdownLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="text-right">
    <mat-icon (click)="close()" style="cursor:pointer">close</mat-icon>
  </div>

  <h3>Optimization</h3>

  <div class="row">

    <!-- Segment -->

    <div class="col-md-6">

      <mat-form-field appearance="outline" class="custom-field">

        <mat-label>Segment</mat-label>

        <mat-select
          [(ngModel)]="filters.segment"
          (selectionChange)="onSegmentChange()">

          <mat-option
            *ngFor="let seg of segments"
            [value]="seg.value">

            {{ seg.key }}

          </mat-option>

        </mat-select>

      </mat-form-field>

    </div>

    <!-- Operation -->

    <div class="col-md-6">

      <mat-form-field appearance="outline" class="custom-field">

        <mat-label>Operation</mat-label>

        <mat-select
          [(ngModel)]="filters.operation"
          (selectionChange)="onOperationChange()">

          <mat-option
            *ngFor="let op of operations"
            [value]="op">

            {{ op }}

          </mat-option>

        </mat-select>

      </mat-form-field>

    </div>

    <!-- Port -->

    <div class="col-md-6 mt-3">

      <mat-form-field appearance="outline" class="custom-field">

        <mat-label>Port Name</mat-label>

        <input
          matInput
          [(ngModel)]="filters.port"
          (input)="filterPorts($event)"
          (focus)="showAllPorts()"
          [matAutocomplete]="autoPort"
          placeholder="Search Port">

        <mat-autocomplete
          #autoPort="matAutocomplete"
          (optionSelected)="selectPort($event.option.value)">

          <mat-option
            *ngFor="let port of filteredPorts"
            [value]="port">

            {{ port.name }}

          </mat-option>

        </mat-autocomplete>

      </mat-form-field>

    </div>

    <!-- Cargo Qty -->

    <div class="col-md-6 mt-3">

      <mat-form-field appearance="outline" class="custom-field">

        <mat-label>Cargo Qty</mat-label>

        <input
          matInput
          type="number"
          [(ngModel)]="filters.cargoQty">

      </mat-form-field>

    </div>

    <!-- Cargo Type -->

    <div class="col-md-6 mt-3">

      <mat-form-field appearance="outline" class="custom-field">

        <mat-label>Type of Cargo</mat-label>

        <mat-select [(ngModel)]="filters.oil">

          <mat-option
            *ngFor="let cargo of cargoTypes"
            [value]="cargo">

            {{ cargo }}

          </mat-option>

        </mat-select>

      </mat-form-field>

    </div>

  </div>

  <!-- Button -->

  <div class="btnCal">

    <button
      class="btn btn-light hover-clear clear d-flex align-items-center justify-content-center"
      (click)="calculateOptimization()"
      [disabled]="isLoading">

      <mat-spinner
        *ngIf="isLoading"
        diameter="20"
        strokeWidth="3"
        style="margin-right:8px">

      </mat-spinner>

      <span *ngIf="!isLoading">Calculate</span>
      <span *ngIf="isLoading">Calculating...</span>

    </button>

  </div>

  <!-- RESULT -->

  <div class="row mt-4 result-container" *ngIf="result">

    <div class="col-md-4">

      <div class="result-card">

        <div class="result-icon fuel">
          <mat-icon>local_gas_station</mat-icon>
        </div>

        <div class="result-content">

          <span class="result-title">
            Bunker Expected in Cargo Ops
          </span>

          <h3>{{ result.expected_total_consumption }}</h3>

        </div>

      </div>

    </div>

    <div class="col-md-4">

      <div class="result-card">

        <div class="result-icon days">
          <mat-icon>calendar_today</mat-icon>
        </div>

        <div class="result-content">

          <span class="result-title">
            No of Days for Cargo Ops
          </span>

          <h3>{{ result.cargo_days_required }}</h3>

        </div>

      </div>

    </div>

    <div class="col-md-4">

      <div class="result-card">

        <div class="result-icon idle">
          <mat-icon>schedule</mat-icon>
        </div>

        <div class="result-content">

          <span class="result-title">
            Bunker Expected in Idle Period
          </span>

          <h3>{{ result.idle_consumption_per_day }}</h3>

        </div>

      </div>

    </div>

  </div>

</div>